/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaTeam = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        jerseyColor1: {
            type: 'string',
            isRequired: true,
        },
        jerseyColor2: {
            type: 'string',
            isRequired: true,
        },
        jerseyMode: {
            type: 'JerseyModeEnum',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        user: {
            type: 'UserMini',
            isRequired: true,
        },
        league: {
            type: 'LeagueListElement',
            isRequired: true,
        },
        fantaPlayerTeams: {
            type: 'array',
            contains: {
                type: 'FantaPlayerTeam',
            },
            isRequired: true,
        },
    },
} as const;
